import React, { useContext } from 'react';
import { Button } from '@components';
import { StepperContext } from '@components/Stepper';
import { useIsMobile } from '@hooks';
import { Stack, Typography, useTheme } from '@mui/material';
import { selectCustomer } from '@store/customer/selectors';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import { PERSONAL_DATA_FIELDS as FIELDS } from '../constants';

const PersonalDataCheckStep: React.FC = () => {
  const theme = useTheme();
  const isMobile = useIsMobile();
  const account = useSelector(selectCustomer);

  const { goToNextStep, setCurrentStep } = useContext(StepperContext);

  if (!account)
    return;

  return (
    <Stack alignItems="center" gap={4} sx={{ my: theme.spacing(5) }}>
      <Typography variant="h2" textAlign="center">
        <FormattedMessage id="preparingForNextSubmission.step.2.1.title" />
      </Typography>
      <Stack 
        sx={{
          padding: isMobile ? '22px' : '34px 56px 40px 56px',
          borderRadius: '8px',
          backgroundColor: theme.palette.grey['600'],
        }}
      >
        {FIELDS.map((field) => (
          <Stack key={field} direction="row" justifyContent="space-between" gap={isMobile ? 2 : 14}>
            <Typography fontSize={18} fontWeight={600}>
              <FormattedMessage id={`signup.${field}.label`} />
            </Typography>
            <Typography fontSize={18}>{(account as any)[field]}</Typography>
          </Stack>
        ))}
      </Stack>
      <Stack direction="row" gap={isMobile ? 2 : 3}>
        <Button variant="outlined" onClick={() => setCurrentStep(3)}>
          <FormattedMessage id="common.no" />
        </Button>
        <Button variant="contained" onClick={goToNextStep}>
          <FormattedMessage id="common.yes" />
        </Button>
      </Stack>
    </Stack>
  );
};

export default PersonalDataCheckStep;
